import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IFlatViewOrder } from '../../types/flatViewOrder';

const initialState: IFlatViewOrder = {
  showTooltip: false,
};

export const flatViewOrderSlice = createSlice({
  name: 'flatViewOrder',
  initialState,
  reducers: {
    toggleFlatViewOrderBanner: (state, action: PayloadAction<boolean>) => {
      state.showTooltip = action.payload;
    },
  },
});

export const {
  reducer: flatViewOrderReducer,
  actions: { toggleFlatViewOrderBanner },
} = flatViewOrderSlice;
